export default __webpack_public_path__ + "static/media/homeslider3.8d96826d.jpg";